import React from "react";

const KycIcon = (props) => (
<svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} viewBox="0 0 24 24" fill="none" {...props}>
    <rect x={3} y={4} width={18} height={16} rx={2} stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" />
    <line x1={7} y1={8} x2={11} y2={8} stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    <line x1={7} y1={12} x2={17} y2={12} stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    <line x1={7} y1={16} x2={13} y2={16} stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
  </svg>
);

export default KycIcon;
